import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 7px;
  display: flex;
  background-color: ${props => props.theme.colors.athensGray};
  position: relative;
  border-radius: ${props => props.theme.space(2.5)};
`;

export const PercentageBar = styled.div`
  width: 100%;
  min-height: 3px;
  background-color: ${props => props.theme.slider.backgroundActive};
  position: relative;
  border-radius: ${props => props.theme.space(2.5)};
  left: 0;
  top: 25%;
  position: absolute;
`;

export const ValueButton = styled.button`
  width: ${props => props.theme.space(3)};
  height: ${props => props.theme.space(3)};
  padding: 0;
  box-shadow: ${props => props.theme.slider.buttonShadow};
  background-color: ${props => props.theme.slider.buttonBackground};
  border: 1px solid ${props => props.theme.colors.shuttleGray};
  border-radius: ${props => props.theme.space(4.5)};
  position: absolute;
  left: -7px;
  top: 50%;
  transform: translate(0%, -50%);
  outline: none;
  transform: ${({ dragPosition }) => `translate(${dragPosition}px,-50%)`};

  &:active {
    border: none;
    background-color: ${props => props.theme.slider.backgroundActive};
    cursor: pointer;
  }
`;
